import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";

const fullName = (user) => `${user.first_name} ${user.last_name}`;

function AssignmentCell({
  row,
  slot,
  users,
  scheduleData,
  onAssignmentChange,
}) {
  const [visible, setVisible] = useState(false);

  const [scheduleEntry, setScheduleEntry] = useState({});

  const [selectedUserId, setSelectedUserId] = useState("");
  let [selectedUser, setSelectedUser] = useState({});

  useEffect(() => {
    let tempScheduleEntry = scheduleData?.find(
      (entry) =>
        entry.match_number === row.match_number && entry.robot_slot === slot
    );
    setScheduleEntry(tempScheduleEntry);
    setSelectedUserId(tempScheduleEntry?.user_id);
    setSelectedUser(
      users.find((u) => u.user_id === tempScheduleEntry?.user_id)
    );
  }, [scheduleData]);

  const handleChange = (event) => {
    const newUserId = event.target.value;

    const change = {
      match_number: row.match_number,
      robot_slot: slot,
      user_id: newUserId,
      schedule_id: scheduleEntry?.schedule_id || null,
    };

    setSelectedUser(users.find((u) => u.user_id === newUserId));

    console.log("Assignment change:", change);
    onAssignmentChange?.(change);
    setSelectedUserId(newUserId);
  };

  return (
    <Box
      onClick={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      sx={{ width: "100%", cursor: "pointer" }}
    >
      {visible ? (
        <FormControl fullWidth size="small">
          <InputLabel>Change...</InputLabel>
          <Select value={selectedUserId} label="Change" onChange={handleChange}>
            {users.map((user) => (
              <MenuItem key={user.user_id} value={user.user_id}>
                {fullName(user)}
              </MenuItem>
            ))}
            <MenuItem key={0} value={null}>
              None
            </MenuItem>
          </Select>
        </FormControl>
      ) : (
        <Typography
          variant="body2"
          sx={{ p: 1, color: selectedUser ? "#ffffff" : "#ff0000" }}
        >
          {selectedUser ? fullName(selectedUser) : "Unassigned"}
        </Typography>
      )}
    </Box>
  );
}

const makeSlotColumn = (slot, users, scheduleData, onAssignmentChange) => ({
  headerName: slot.replace(/([a-z])([A-Z])/g, "$1 $2"),
  field: slot,
  width: 200,
  editable: false,
  renderCell: (params) => (
    <AssignmentCell
      row={params.row}
      slot={slot}
      users={users}
      scheduleData={scheduleData}
      onAssignmentChange={onAssignmentChange}
    />
  ),
});

export const makeScheduleCols = (scheduleData, users, onAssignmentChange) => [
  {
    headerName: "Match",
    field: "match_number",
    width: 80,
    editable: false,
  },
  { field: "red_group", headerName: "Red Group", width: 150 },
  makeSlotColumn("red1", users, scheduleData, onAssignmentChange),
  makeSlotColumn("red2", users, scheduleData, onAssignmentChange),
  makeSlotColumn("red3", users, scheduleData, onAssignmentChange),
  { field: "blue_group", headerName: "Blue Group", width: 150 },
  makeSlotColumn("blue1", users, scheduleData, onAssignmentChange),
  makeSlotColumn("blue2", users, scheduleData, onAssignmentChange),
  makeSlotColumn("blue3", users, scheduleData, onAssignmentChange),
];
